<template>
    <div v-if="tourQuestions && tourQuestions.length > 0" class="tw-mb-6">
        <div class="tw-space-y-4">
            <div 
                v-for="(question, questionIndex) in tourQuestions" 
                :key="questionIndex"
            >
                <h4 class="tw-font-medium tw-mb-3">{{ question.question }}</h4>
                
                <!-- Combined Single & Multiple Choice Questions -->
                <div class="tw-space-y-2">
                    <label 
                        v-for="(answer, answerIndex) in question.answers" 
                        :key="answerIndex"
                        class="tw-flex tw-items-center tw-cursor-pointer"
                    >
                        <input 
                            :type="question.questionType === 'singleChoice' ? 'radio' : 'checkbox'"
                            :name="question.questionType === 'singleChoice' ? 'question_' + questionIndex : null"
                            :value="answer.answerText"
                            :checked="selectedAnswers[questionIndex].answer.includes(answer.answerText)"
                            class="tw-mr-2 tw-w-4 tw-h-4 tw-accent-brand"
                            @change="handleAnswerChange(questionIndex, answer.answerText, question.questionType, $event)"
                        />
                        <span>{{ answer.answerText }}</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    name: "TourQuestions",
    props: {
        tour: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            selectedAnswers: [],
            tourQuestions: []
        };
    },
    computed: {
        ...mapGetters({
            travelData: 'tour/travelData'
        })
    },
    mounted() {
        this.loadTourQuestions();
        this.initializeSelectedAnswers();
    },
    methods: {
        loadTourQuestions() {
            try {
                // Tour questions come from the main country of the tour
                if (this.tour?.mainCountry?.tourQuestions) {
                    this.tourQuestions = this.tour.mainCountry.tourQuestions;
                } else {
                    this.tourQuestions = [];
                }
            } catch (error) {
                console.error('Error loading tour questions:', error);
                this.tourQuestions = [];
            }
        },
        initializeSelectedAnswers() {
            this.selectedAnswers = [];
            // Get saved answers from the store if they exist
            const savedAnswers = this.travelData?.tourQuestions || [];
            
            this.tourQuestions.forEach((question, index) => {
                // Check if there's a saved answer for this question
                const savedAnswer = savedAnswers.find(saved => saved.question === question.question);
                
                this.selectedAnswers[index] = {
                    question: question.question,
                    answer: savedAnswer ? (Array.isArray(savedAnswer.answer) ? savedAnswer.answer : [savedAnswer.answer]) : []
                };
            });
            // Don't emit answers during initialization - only when user makes changes
        },
        handleAnswerChange(questionIndex, answerText, questionType, event) {
            if (questionType === 'singleChoice') {
                // For single choice, replace the array with the selected answer
                if (event.target.checked) {
                    this.selectedAnswers[questionIndex].answer = [answerText];
                }
            } else {
                // For multiple choice, add or remove from array
                if (event.target.checked) {
                    if (!this.selectedAnswers[questionIndex].answer.includes(answerText)) {
                        this.selectedAnswers[questionIndex].answer.push(answerText);
                    }
                } else {
                    const index = this.selectedAnswers[questionIndex].answer.indexOf(answerText);
                    if (index > -1) {
                        this.selectedAnswers[questionIndex].answer.splice(index, 1);
                    }
                }
            }
            this.updateAnswers();
        },
        updateAnswers() {
            // Emit the selected answers to parent component
            this.$emit('answers-updated', this.selectedAnswers);
            
            // Store in Vuex store if available
            if (this.$store && this.$store.commit) {
                this.$store.commit('tour/setTourQuestionAnswers', this.selectedAnswers);
            }
        }
    },
    watch: {
        tour: {
            handler() {
                this.loadTourQuestions();
                this.initializeSelectedAnswers();
            },
            deep: true
        },
        travelData: {
            handler() {
                // Re-initialize answers when travel data changes (e.g., when loaded from localStorage)
                if (this.tourQuestions.length > 0) {
                    this.initializeSelectedAnswers();
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped>
</style>
